import { makeStyles } from "@mui/styles"
import { flow, pipe } from "fp-ts/es6/function.js"
import { always, cond, defaultTo, equals, mergeAll, T } from "ramda"

export const useOverrides = makeStyles(({ typography, withPalette }) => ({
  disabled: {
    "&[class*='MuiButton-root']": {
      "&:not([class*='MuiButton-text'])": {
        backgroundColor: withPalette("disabled"),
        border: "2pt solid #9b9b9b",
        color: "#757575",
      },
      "&[class*='MuiButton-text']": { color: `${withPalette("disabled")} !important` },
    },
  },
  outlined: {
    "&[class*='MuiButton-outlined']": {
      background: "#fff",
      borderStyle: "solid",
      borderWidth: "2pt",
      padding: [[0, 22]],
    },
  },
  root: {
    "&[class*='MuiButton-root']": {
      fontSize: typography.pxToRem(14),
      fontWeight: 700,
      height: 38,
      textTransform: "initial",
    },
    "&[class*='MuiTouchRipple-root']": { borderRadius: 2 },
  },
}))

export const useDynamicOverrides = makeStyles(({ withPalette }) => ({
  contained: ({ background, backgroundOnHover, color, fontColor, hoverStyle, pending }) => ({
    "&[class*='MuiButton-contained']": {
      "&:hover": {
        color: withPalette(color, "contrastText", fontColor),
        ...(hoverStyle === "never"
          ? {
              backgroundColor: defaultTo(withPalette(color), background),
              border: `2pt solid ${defaultTo(withPalette(color), background)}`,
            }
          : {
              backgroundColor: defaultTo(withPalette(color, "dark"), backgroundOnHover),
              border: `2pt solid ${defaultTo(withPalette(color, "dark"), backgroundOnHover)}`,
            }),
      },
      backgroundColor: defaultTo(withPalette(color), background),
      border:
        hoverStyle === "always"
          ? `2pt solid ${defaultTo(withPalette(color, "dark"), backgroundOnHover)}`
          : `2pt solid ${defaultTo(withPalette(color), background)}`,
      color: withPalette(color, "contrastText", fontColor),
      pointerEvents: pending ? "none" : "auto",
    },
  }),
  outlined: ({ color, hoverStyle }) => {
    const usingSecondaryColor = equals(color, "secondary")
    const borderColorSecondary = withPalette("background3")

    return {
      "&[class*='MuiButton-outlined']": {
        "&:hover": {
          backgroundColor: "white",
          borderWidth: "2pt",
          ...({
            never: {
              borderColor: usingSecondaryColor ? borderColorSecondary : withPalette(color, "light"),
              color: withPalette(color, usingSecondaryColor ? "contrastText" : "main"),
            },
            always: {
              border: `2pt solid ${
                usingSecondaryColor ? borderColorSecondary : withPalette(color, "light")
              }`,
            },
          }[hoverStyle] || {
            borderColor: withPalette(color, usingSecondaryColor ? "contrastText" : "main"),
          }),
        },
        backgroundColor: "white",
        borderColor: usingSecondaryColor ? borderColorSecondary : withPalette(color, "light"),
        color: withPalette(color, usingSecondaryColor ? "contrastText" : "main"),
      },
    }
  },
  root: ({ height, padding, width }) => ({
    "&[class*='MuiButton-root']": {
      height,
      padding: [padding],
      width,
    },
  }),

  text: ({ color }) => {
    const usingSecondaryColor = equals(color, "secondary")

    return {
      "&[class*='MuiButton-text']": {
        "&:hover": {
          backgroundColor: "#0000000a",
        },
        color: withPalette(color, usingSecondaryColor ? "contrastText" : "main"),
      },
    }
  },
}))
